// Countries - Economic Growth card game data - ranked by GDP
export const COUNTRIES_GDP_CARDS = [
  { id: 1, name: "The United States", rank: 1, image: "/images/countriesGdp/countriesGdp_1.jpg" },
  { id: 2, name: "China", rank: 2, image: "/images/countriesGdp/countriesGdp_2.jpg" },
  { id: 3, name: "Germany", rank: 3, image: "/images/countriesGdp/countriesGdp_3.jpg" },
  { id: 4, name: "Japan", rank: 4, image: "/images/countriesGdp/countriesGdp_4.jpg" },
  { id: 5, name: "India", rank: 5, image: "/images/countriesGdp/countriesGdp_5.jpg" },
  { id: 6, name: "The UK", rank: 6, image: "/images/countriesGdp/countriesGdp_6.jpg" },
  { id: 7, name: "France", rank: 7, image: "/images/countriesGdp/countriesGdp_7.jpg" },
  { id: 8, name: "Italy", rank: 8, image: "/images/countriesGdp/countriesGdp_8.jpg" },
  { id: 9, name: "Russia", rank: 9, image: "/images/countriesGdp/countriesGdp_9.jpg" },
  { id: 10, name: "Canada", rank: 10, image: "/images/countriesGdp/countriesGdp_10.jpg" },
  { id: 11, name: "Brazil", rank: 11, image: "/images/countriesGdp/countriesGdp_11.jpg" },
  { id: 12, name: "Spain", rank: 12, image: "/images/countriesGdp/countriesGdp_12.jpg" },
  { id: 13, name: "Mexico", rank: 13, image: "/images/countriesGdp/countriesGdp_13.jpg" },
  { id: 14, name: "South Korea", rank: 14, image: "/images/countriesGdp/countriesGdp_14.jpg" },
  { id: 15, name: "Australia", rank: 15, image: "/images/countriesGdp/countriesGdp_15.jpg" },
  { id: 16, name: "Türkiye", rank: 16, image: "/images/countriesGdp/countriesGdp_16.jpg" },
  { id: 17, name: "Indonesia", rank: 17, image: "/images/countriesGdp/countriesGdp_17.jpg" },
  { id: 18, name: "Netherlands", rank: 18, image: "/images/countriesGdp/countriesGdp_18.jpg" },
  { id: 19, name: "Saudi Arabia", rank: 19, image: "/images/countriesGdp/countriesGdp_19.jpg" },
  { id: 20, name: "Poland", rank: 20, image: "/images/countriesGdp/countriesGdp_20.jpg" }
];
